import { render, staticRenderFns } from "./dictionaryType.vue?vue&type=template&id=b3859e6e&scoped=true"
import script from "./dictionaryType.vue?vue&type=script&lang=js"
export * from "./dictionaryType.vue?vue&type=script&lang=js"
import style0 from "./dictionaryType.vue?vue&type=style&index=0&id=b3859e6e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3859e6e",
  null
  
)

export default component.exports